import React, { useState, useEffect } from 'react';
import api from '../../../services/api';
import { useAuth } from '../../../hooks/useAuth';
import { Select, Button, Table, Card, Row, Col, Typography, DatePicker } from 'antd';
import PrintButton from '../../../components/admin/PrintButton';

const { Option } = Select;
const { Title } = Typography;
const { RangePicker } = DatePicker;

const ActivityLogReport = () => {
  const [activities, setActivities] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    userId: null,
    dates: null,
  });
  const { token } = useAuth();

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await api.get('/api/users', {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUsers(response.data);
      } catch (error) {
        console.error('Failed to fetch users for filter', error);
      }
    };
    if (token) {
      fetchUsers();
    }
  }, [token]);

  const fetchActivities = async () => {
    setLoading(true);
    try {
      const params = {};
      if (filters.userId) {
        params.userId = filters.userId;
      }
      if (filters.dates && filters.dates.length === 2) {
        params.startDate = filters.dates[0].toISOString();
        params.endDate = filters.dates[1].toISOString();
      }
      const response = await api.get('/api/admin/activity-log', {
        headers: { Authorization: `Bearer ${token}` },
        params,
      });
      setActivities(response.data.activities);
    } catch (error) {
      console.error('Failed to fetch activity log', error);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (key, value) => {
    setFilters(prev => ({ ...prev, [key]: value }));
  };

  const handleSearch = () => {
    fetchActivities();
  };

  useEffect(() => {
    fetchActivities();
  }, [token]);

  const columns = [
    { title: 'المستخدم', dataIndex: 'username', key: 'username' },
    { title: 'الإجراء', dataIndex: 'action', key: 'action' },
    { title: 'نوع الإجراء', dataIndex: 'actionType', key: 'actionType' },
    { title: 'التفاصيل', dataIndex: 'details', key: 'details' },
    { title: 'عنوان IP', dataIndex: 'ipAddress', key: 'ipAddress' },
    {
      title: 'التاريخ',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (date) => new Date(date).toLocaleString('ar-SA'),
    },
  ];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Title level={3}>تقرير سجل النشاط</Title>
        <PrintButton />
      </div>
      <Card title="تقرير سجل النشاط">
        <div>
          <Row gutter={16} style={{ marginBottom: 16 }} className="no-print">
            <Col>
              <Select
                placeholder="اختر مستخدم"
                style={{ width: 200 }}
                onChange={(value) => handleFilterChange('userId', value)}
                allowClear
              >
                {users.map((user) => (
                  <Option key={user.id} value={user.id}>
                    {user.username}
                  </Option>
                ))}
              </Select>
            </Col>
            <Col>
              <RangePicker
                onChange={(dates) => handleFilterChange('dates', dates)}
                placeholder={['تاريخ البدء', 'تاريخ الانتهاء']}
              />
            </Col>
            <Col>
              <Button type="primary" onClick={handleSearch}>
                بحث
              </Button>
            </Col>
          </Row>
          <Table
            dataSource={activities}
            columns={columns}
            rowKey="id"
            loading={loading}
            scroll={{ x: true }}
          />
        </div>
      </Card>
    </div>
  );
};

export default ActivityLogReport;